var render = function () {
  var _vm$shoppingCategory, _vm$bestsellerCategor2, _vm$bestsellerCategor3, _vm$bestsellerCategor4, _vm$childrenCategory, _vm$childrenCategory2, _vm$childrenCategory3, _vm$discountCategory, _vm$discountCategory2, _vm$discountCategory3, _vm$shoppingCategory2, _vm$shoppingCategory3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    staticClass: "app",
    style: {
      backgroundColor: _vm.backgroundColor
    },
    attrs: {
      "id": "inspire"
    }
  }, [!_vm.$vuetify.breakpoint.mobile ? _c('v-app-bar', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onScroll,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onScroll, options: { threshold: [0, 1.0] } }"
    }],
    staticClass: "header pa-0 ma-0",
    attrs: {
      "app": "",
      "height": "120",
      "extension-height": "60",
      "absolute": "",
      "elevation": "0",
      "color": "white"
    }
  }, [_c('v-responsive', {
    staticClass: "mx-auto logo-wrap",
    attrs: {
      "width": "100%",
      "max-width": "1200",
      "height": "120"
    }
  }, [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.state.ui.logo.pc,
      "alt": "DAEHAN BOOKSTORE"
    }
  })])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.scope.includes('cert'),
      expression: "scope.includes('cert')"
    }],
    staticClass: "header-timer"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-alarm")]), _vm._v(_vm._s(_vm.remain()))], 1)], 1), _c('v-responsive', {
    staticClass: "ma-0 overflow-visible",
    attrs: {
      "slot": "extension",
      "width": "100%"
    },
    slot: "extension"
  }, [_c('v-divider', {
    staticClass: "mb-n1px"
  }), _c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "overflow-visible",
    attrs: {
      "width": "100%",
      "max-width": _vm.maxWidth
    }
  }, [_c('global-navigation-bar', [_c('v-menu', {
    attrs: {
      "slot": "prepend",
      "tile": "",
      "open-on-hover": "",
      "offset-y": "",
      "close-on-content-click": false
    },
    slot: "prepend",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return _c('v-btn', _vm._g({
          attrs: {
            "width": "120",
            "height": "60",
            "x-large": "",
            "tile": "",
            "color": "primary darken-4"
          }
        }, on), [_c('v-icon', {
          staticClass: "mr-2 mt-1",
          attrs: {
            "size": "28"
          }
        }, [_vm._v("mdi-menu")]), _c('span', {
          staticClass: "font-size-18"
        }, [_vm._v("전체")])], 1);
      }
    }], null, false, 3033564550)
  }, [_c('v-list', {
    staticClass: "prepend-menu"
  }, [_c('div', {
    staticClass: "prepend-menu__li"
  }, [_c('div', {
    staticClass: "prepend-menu__tit"
  }, [_vm._v("도서")]), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/bestseller"
    }
  }, [_vm._v("베스트셀러")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/children"
    }
  }, [_vm._v("유아동")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/independent"
    }
  }, [_vm._v("독립출판물")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/discount"
    }
  }, [_vm._v("할인도서")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/exchange"
    }
  }, [_vm._v("모바일 도서교환권")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/ebook"
    }
  }, [_vm._v("eBook")])], 1)])]), _c('div', {
    staticClass: "prepend-menu__li"
  }, [_c('div', {
    staticClass: "prepend-menu__tit"
  }, [_vm._v("나누리 상품권")]), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/purchase"
    }
  }, [_vm._v("상품권 구매")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/mypage/cashes/charge"
    }
  }, [_vm._v("상품권 충전")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/exchange"
    }
  }, [_vm._v("상품권 교환소")])], 1)])]), _c('div', {
    staticClass: "prepend-menu__li"
  }, [_c('div', {
    staticClass: "prepend-menu__tit"
  }, [_vm._v("쿠폰")]), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/gshop/brand?_category&page=1"
    }
  }, [_vm._v("쿠폰교환소")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/dshop/products"
    }
  }, [_vm._v("배송상품")])], 1)])]), _c('div', {
    staticClass: "prepend-menu__li"
  }, [_c('router-link', {
    staticClass: "prepend-menu__tit",
    attrs: {
      "to": {
        path: '/shop/products',
        query: {
          _category: (_vm$shoppingCategory = _vm.shoppingCategory) === null || _vm$shoppingCategory === void 0 ? void 0 : _vm$shoppingCategory._id,
          page: 1
        }
      }
    }
  }, [_vm._v("쇼핑")])], 1), _c('div', {
    staticClass: "prepend-menu__li"
  }, [_c('router-link', {
    staticClass: "prepend-menu__tit",
    attrs: {
      "to": "/offerwall"
    }
  }, [_vm._v("캐시 리워드")])], 1), _c('div', {
    staticClass: "prepend-menu__li"
  }, [_c('div', {
    staticClass: "prepend-menu__tit"
  }, [_vm._v("고객센터")]), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/center/notifications"
    }
  }, [_vm._v("공지사항")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/center/faqs"
    }
  }, [_vm._v("자주 묻는 질문")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/center/questions"
    }
  }, [_vm._v("1:1 문의")])], 1)])])])], 1), _c('v-layout', {
    staticClass: "px-20px",
    attrs: {
      "slot": "center"
    },
    slot: "center"
  }, [_c('v-menu', {
    attrs: {
      "slot": "prepend",
      "tile": "",
      "open-on-hover": "",
      "offset-y": ""
    },
    slot: "prepend",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var _vm$bestsellerCategor;

        var on = _ref2.on;
        return _c('v-btn', _vm._g({
          staticClass: "font-size-18 px-20px",
          attrs: {
            "to": "/shop/bestseller?_category=".concat((_vm$bestsellerCategor = _vm.bestsellerCategory) === null || _vm$bestsellerCategor === void 0 ? void 0 : _vm$bestsellerCategor._id),
            "ripple": false,
            "active-class": "no-active",
            "height": "60",
            "dark": "",
            "text": "",
            "tile": "",
            "x-large": "",
            "color": "black"
          }
        }, on), [_vm._v("도서")]);
      }
    }], null, false, 3020027240)
  }, [_c('div', {
    staticStyle: {
      "width": "390px",
      "height": "600px"
    }
  }, [_c('v-list', {
    staticClass: "prepend-menu-sub"
  }, [_c('div', {
    staticClass: "prepend-menu-sub__li prepend-menu-sub__li__dept3-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": "/shop/bestseller?_category=".concat((_vm$bestsellerCategor2 = _vm.bestsellerCategory) === null || _vm$bestsellerCategor2 === void 0 ? void 0 : _vm$bestsellerCategor2._id)
    }
  }, [_vm._v("베스트셀러")]), _c('ul', {
    staticClass: "prepend-menu-sub__li__dept3"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/bestseller?_category=".concat((_vm$bestsellerCategor3 = _vm.bestsellerCategory) === null || _vm$bestsellerCategor3 === void 0 ? void 0 : _vm$bestsellerCategor3._id)
    }
  }, [_vm._v("전체")])], 1), _vm._l((_vm$bestsellerCategor4 = _vm.bestsellerCategory) === null || _vm$bestsellerCategor4 === void 0 ? void 0 : _vm$bestsellerCategor4.children, function (category) {
    return _c('li', {
      key: category._id
    }, [_c('router-link', {
      attrs: {
        "to": "/shop/bestseller?_category=".concat(category._id)
      }
    }, [_vm._v(_vm._s(category.name))])], 1);
  })], 2)], 1), _c('div', {
    staticClass: "prepend-menu-sub__li prepend-menu-sub__li__dept3-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": "/shop/children?_category=".concat((_vm$childrenCategory = _vm.childrenCategory) === null || _vm$childrenCategory === void 0 ? void 0 : _vm$childrenCategory._id)
    }
  }, [_vm._v("유아동")]), _c('ul', {
    staticClass: "prepend-menu-sub__li__dept3"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/children?_category=".concat((_vm$childrenCategory2 = _vm.childrenCategory) === null || _vm$childrenCategory2 === void 0 ? void 0 : _vm$childrenCategory2._id)
    }
  }, [_vm._v("전체")])], 1), _vm._l((_vm$childrenCategory3 = _vm.childrenCategory) === null || _vm$childrenCategory3 === void 0 ? void 0 : _vm$childrenCategory3.children, function (category) {
    return _c('li', {
      key: category._id
    }, [_c('router-link', {
      attrs: {
        "to": "/shop/children?_category=".concat(category._id)
      }
    }, [_vm._v(_vm._s(category.name))])], 1);
  })], 2)], 1), _c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/shop/independent"
    }
  }, [_vm._v("독립출판물")])], 1), _c('div', {
    staticClass: "prepend-menu-sub__li prepend-menu-sub__li__dept3-wrap"
  }, [_c('router-link', {
    attrs: {
      "to": "/shop/discount?_category=".concat((_vm$discountCategory = _vm.discountCategory) === null || _vm$discountCategory === void 0 ? void 0 : _vm$discountCategory._id)
    }
  }, [_vm._v("할인도서")]), _c('ul', {
    staticClass: "prepend-menu-sub__li__dept3"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/shop/discount?_category=".concat((_vm$discountCategory2 = _vm.discountCategory) === null || _vm$discountCategory2 === void 0 ? void 0 : _vm$discountCategory2._id)
    }
  }, [_vm._v("전체")])], 1), _vm._l((_vm$discountCategory3 = _vm.discountCategory) === null || _vm$discountCategory3 === void 0 ? void 0 : _vm$discountCategory3.children, function (category) {
    return _c('li', {
      key: category._id
    }, [_c('router-link', {
      attrs: {
        "to": "/shop/discount?_category=".concat(category._id)
      }
    }, [_vm._v(_vm._s(category.name))])], 1);
  })], 2)], 1), _c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/shop/exchange"
    }
  }, [_vm._v("모바일 도서교환권")])], 1), _c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/shop/ebook"
    }
  }, [_vm._v("eBook")])], 1)])], 1)]), _c('v-menu', {
    attrs: {
      "slot": "prepend",
      "tile": "",
      "open-on-hover": "",
      "offset-y": ""
    },
    slot: "prepend",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on;
        return _c('v-btn', _vm._g({
          staticClass: "font-size-18 px-20px",
          attrs: {
            "to": "/exchange",
            "ripple": false,
            "active-class": "no-active",
            "height": "60",
            "dark": "",
            "text": "",
            "tile": "",
            "x-large": "",
            "color": "black"
          }
        }, on), [_vm._v("나누리 상품권")]);
      }
    }], null, false, 593631465)
  }, [_c('v-list', {
    staticClass: "prepend-menu-sub"
  }, [_c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/purchase"
    }
  }, [_vm._v("상품권 구매")])], 1), _c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage/cashes/charge"
    }
  }, [_vm._v("상품권 충전")])], 1), _c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/exchange"
    }
  }, [_vm._v("상품권 교환소")])], 1)])], 1), _c('v-menu', {
    attrs: {
      "slot": "prepend",
      "tile": "",
      "open-on-hover": "",
      "offset-y": ""
    },
    slot: "prepend",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on;
        return _c('v-btn', _vm._g({
          staticClass: "font-size-18 px-20px",
          attrs: {
            "to": "/gshop/brand?_category&page=1",
            "ripple": false,
            "active-class": "no-active",
            "height": "60",
            "dark": "",
            "text": "",
            "tile": "",
            "x-large": "",
            "color": "black"
          }
        }, on), [_vm._v("쿠폰")]);
      }
    }], null, false, 1610218697)
  }, [_c('v-list', {
    staticClass: "prepend-menu-sub"
  }, [_c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/gshop/brand?_category&page=1"
    }
  }, [_vm._v("쿠폰교환소")])], 1), _c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/dshop/products"
    }
  }, [_vm._v("배송상품")])], 1)])], 1), _c('v-btn', {
    staticClass: "font-size-18 px-20px",
    attrs: {
      "to": {
        path: '/shop/products',
        query: {
          _category: (_vm$shoppingCategory2 = _vm.shoppingCategory) === null || _vm$shoppingCategory2 === void 0 ? void 0 : _vm$shoppingCategory2._id,
          page: 1
        }
      },
      "ripple": false,
      "active-class": "no-active",
      "height": "60",
      "dark": "",
      "text": "",
      "tile": "",
      "x-large": "",
      "color": "black"
    }
  }, [_vm._v("쇼핑")]), _c('v-btn', {
    staticClass: "font-size-18 px-30px",
    attrs: {
      "to": "/board/event",
      "ripple": false,
      "active-class": "no-active",
      "height": "60",
      "dark": "",
      "text": "",
      "tile": "",
      "x-large": "",
      "color": "black"
    }
  }, [_vm._v("이벤트")]), _c('v-btn', {
    staticClass: "font-size-18 px-30px new",
    attrs: {
      "to": "/offerwall",
      "ripple": false,
      "active-class": "no-active",
      "height": "60",
      "dark": "",
      "text": "",
      "tile": "",
      "x-large": "",
      "color": "black"
    }
  }, [_vm._v("캐시 리워드")]), _c('v-menu', {
    attrs: {
      "slot": "prepend",
      "tile": "",
      "open-on-hover": "",
      "offset-y": ""
    },
    slot: "prepend",
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref5) {
        var on = _ref5.on;
        return _c('v-btn', _vm._g({
          staticClass: "font-size-18 px-20px",
          attrs: {
            "to": "/center/notifications",
            "ripple": false,
            "active-class": "no-active",
            "height": "60",
            "dark": "",
            "text": "",
            "tile": "",
            "x-large": "",
            "color": "black"
          }
        }, on), [_vm._v("고객센터")]);
      }
    }], null, false, 3469181836)
  }, [_c('v-list', {
    staticClass: "prepend-menu-sub"
  }, [_c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/center/notifications"
    }
  }, [_vm._v("공지사항")])], 1), _c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/center/faqs"
    }
  }, [_vm._v("자주묻는질문")])], 1), _c('div', {
    staticClass: "prepend-menu-sub__li"
  }, [_c('router-link', {
    attrs: {
      "to": "/center/questions"
    }
  }, [_vm._v("1:1 문의")])], 1)])], 1)], 1), _c('v-responsive', {
    staticClass: "px-4",
    attrs: {
      "slot": "append",
      "width": "100%",
      "height": "60"
    },
    slot: "append"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', {
    attrs: {
      "name": "searchValue",
      "type": "search",
      "autocomplete": "off",
      "placeholder": "도서, 상품 검색",
      "hide-details": "",
      "height": "60"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event);
      }
    },
    model: {
      value: _vm.searchValue,
      callback: function callback($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  })], 1), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.searchValue,
      expression: "searchValue"
    }],
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "28"
    },
    on: {
      "click": function click($event) {
        _vm.searchValue = null;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "28"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("mdi-magnify")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.$vuetify.breakpoint.mobile ? _c('v-app-bar', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onScroll,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onScroll, options: { threshold: [0, 1.0] } }"
    }],
    attrs: {
      "height": "130",
      "color": "white",
      "elevation": "0"
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "fill-height": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "width": "100%",
      "height": "60"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-app-bar-nav-icon', {
    staticClass: "transparent",
    attrs: {
      "width": "60",
      "height": "60"
    },
    on: {
      "click": function click($event) {
        _vm.drawer = true;
      }
    }
  }), _c('v-spacer'), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "max-width": "190px",
      "height": "48px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.state.ui.logo.mobile,
      "alt": "DAEHAN BOOKSTORE"
    }
  })])]), _c('v-spacer'), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.scope.includes('cert'),
      expression: "scope.includes('cert')"
    }],
    staticClass: "font-size-14 ml-8px",
    staticStyle: {
      "width": "58px"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2px",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-alarm")]), _vm._v(_vm._s(_vm.remain()) + " ")], 1), _c('v-btn', {
    staticClass: "transparent",
    attrs: {
      "icon": "",
      "to": "/mypage/shop/carts",
      "width": "60",
      "height": "60",
      "active-class": "no-active"
    }
  }, [_c('v-icon', [_vm._v("mdi-cart")])], 1)], 1)], 1), _c('v-responsive', {
    attrs: {
      "width": "100%",
      "height": "70"
    }
  }, [_c('v-container', {
    staticClass: "pt-8px"
  }, [_c('v-text-field', {
    staticClass: "v-input--large primary",
    attrs: {
      "type": "search",
      "autocomplete": "off",
      "outlined": "",
      "hide-details": "",
      "clearable": "",
      "background-color": "white",
      "placeholder": "도서, 상품 검색",
      "append-icon": "mdi-magnify"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event);
      },
      "click:append": _vm.search
    },
    model: {
      value: _vm.searchValue,
      callback: function callback($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  })], 1), _c('v-divider', {
    staticClass: "border-2 primary mt-12px"
  })], 1)], 1)], 1) : _vm._e(), _c('v-navigation-drawer', {
    staticClass: "mobile-navigation-drawer grey lighten-4",
    attrs: {
      "app": "",
      "fixed": "",
      "temporary": "",
      "height": "auto",
      "width": "100%",
      "touchless": ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-item', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-account-circle")])], 1), _c('v-list-item-title', [_vm.logoff ? _c('span', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("로그인")]) : _vm._e(), _vm.logon ? _c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("로그아웃")]) : _vm._e()]), _c('v-list-item-action', {
    on: {
      "click": function click($event) {
        _vm.drawer = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-list-group', {
    staticClass: "white"
  }, [_c('v-list-item-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('b', [_vm._v("도서")])]), _c('v-divider'), _c('v-list-item-group', [_c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/shop/bestseller"
    }
  }, [_c('v-list-item-title', [_vm._v("베스트셀러")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/shop/children"
    }
  }, [_c('v-list-item-title', [_vm._v("유아동")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/shop/independent"
    }
  }, [_c('v-list-item-title', [_vm._v("독립출판물")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/shop/discount"
    }
  }, [_c('v-list-item-title', [_vm._v("할인도서")])], 1)], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/shop/exchange"
    }
  }, [_c('v-list-item-title', [_vm._v("모바일 도서교환권")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/shop/ebook"
    }
  }, [_c('v-list-item-title', [_vm._v("eBook")])], 1)], 1), _c('v-divider'), _c('v-list-group', {
    staticClass: "white"
  }, [_c('v-list-item-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('b', [_vm._v("나누리 상품권")])]), _c('v-divider'), _c('v-list-item-group', [_c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/purchase"
    }
  }, [_c('v-list-item-title', [_vm._v("상품권 구매")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/mypage/cashes/charge"
    }
  }, [_c('v-list-item-title', [_vm._v("상품권 충전")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/exchange"
    }
  }, [_c('v-list-item-title', [_vm._v("상품권 교환소")])], 1)], 1)], 1), _c('v-divider'), _c('v-list-group', {
    staticClass: "white"
  }, [_c('v-list-item-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('b', [_vm._v("쿠폰")])]), _c('v-divider'), _c('v-list-item-group', [_c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/gshop/brand?_category&page=1"
    }
  }, [_c('v-list-item-title', [_vm._v("쿠폰교환소")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/dshop/products"
    }
  }, [_c('v-list-item-title', [_vm._v("배송상품")])], 1)], 1)], 1), _c('v-divider'), _c('v-list-item', {
    staticClass: "white",
    attrs: {
      "active-class": "no-active",
      "to": {
        path: '/shop/products',
        query: {
          _category: (_vm$shoppingCategory3 = _vm.shoppingCategory) === null || _vm$shoppingCategory3 === void 0 ? void 0 : _vm$shoppingCategory3._id,
          page: 1
        }
      }
    }
  }, [_c('v-list-item-title', [_c('b', [_vm._v("쇼핑")])])], 1), _c('v-divider'), _c('v-list-item', {
    staticClass: "white",
    attrs: {
      "active-class": "no-active",
      "to": "/board/event"
    }
  }, [_c('v-list-item-title', [_c('b', [_vm._v("이벤트")])])], 1), _c('v-divider'), _c('v-list-item', {
    staticClass: "white new",
    attrs: {
      "active-class": "no-active",
      "to": "/offerwall"
    }
  }, [_c('v-list-item-title', [_c('b', [_vm._v("캐시 리워드")])])], 1), _c('v-divider'), _c('v-list-group', {
    staticClass: "white"
  }, [_c('v-list-item-title', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('b', [_vm._v("고객센터")])]), _c('v-divider'), _c('v-list-item-group', [_c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/center/notifications"
    }
  }, [_c('v-list-item-title', [_vm._v("공지사항")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/center/faqs"
    }
  }, [_c('v-list-item-title', [_vm._v("자주묻는질문")])], 1), _c('v-list-item', {
    attrs: {
      "active-class": "no-active",
      "to": "/center/questions"
    }
  }, [_c('v-list-item-title', [_vm._v("1:1 문의")])], 1)], 1)], 1), _c('v-divider'), _c('v-layout', {
    staticClass: "mt-2 px-1"
  }, [_c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "width": "100%",
      "height": "80",
      "color": "white",
      "elevation": "0",
      "to": "/mypage",
      "active-class": "no-active"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-account-outline")]), _c('span', [_vm._v("마이페이지")])], 1)])], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "width": "100%",
      "height": "80",
      "color": "white",
      "elevation": "0",
      "to": "/mypage/shop/carts",
      "active-class": "no-active"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-cart-outline")]), _c('span', [_vm._v("장바구니")])], 1)])], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "width": "100%",
      "height": "80",
      "color": "white",
      "elevation": "0",
      "to": "/mypage/shop/purchases",
      "active-class": "no-active"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', {
    staticClass: "d-block mx-auto",
    attrs: {
      "color": "primary",
      "size": "32"
    }
  }, [_vm._v("mdi-text-box-outline")]), _c('span', [_vm._v("주문배송조회")])], 1)])], 1)], 1), _c('div', {
    staticClass: "font-size-14 font-weight-medium white grey--text text--darken-3 pa-16px mt-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("대표전화")]), _c('v-divider', {
    staticClass: "my-8px"
  }), _c('div', {
    staticClass: "mt-2px"
  }, [_c('span', [_vm._v("Tel.")]), _c('span', {
    staticClass: "font-size-22 font-weight-bold secondary--text ml-4px"
  }, [_vm._v("1800-9510")])]), _c('div', {
    staticClass: "mt-2px"
  }, [_c('span', [_vm._v("평일 10:00 - 17:00 / 점심 12:30 - 13:30")])]), _c('div', {
    staticClass: "mt-2px"
  }, [_c('span', [_vm._v("주말 및 공휴일 휴무")])])], 1)], 1)], 1), _c('client-floating-actions', _vm._g(_vm._b({}, 'client-floating-actions', {
    logoff: _vm.logoff,
    logon: _vm.logon
  }, false), {
    logout: _vm.logout
  })), _c('client-gift-noti', _vm._b({}, 'client-gift-noti', {
    logon: _vm.logon
  }, false)), _c('v-main', {
    attrs: {
      "id": "main"
    }
  }, [_c('div', {
    attrs: {
      "id": "contents"
    }
  }, [_vm._t("default")], 2)]), _c('v-responsive', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect",
      value: {
        handler: _vm.onFooter,
        options: {
          threshold: [0, 1.0]
        }
      },
      expression: "{ handler: onFooter, options: { threshold: [0, 1.0] } }"
    }],
    attrs: {
      "min-height": "200"
    }
  }, [_c('v-lazy', {
    attrs: {
      "transition": "fade-transition"
    },
    model: {
      value: _vm.showFooter,
      callback: function callback($$v) {
        _vm.showFooter = $$v;
      },
      expression: "showFooter"
    }
  }, [_c('v-footer', {
    staticClass: "px-0 py-10px py-md-18px",
    attrs: {
      "color": "#51575b"
    }
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    staticClass: "font-size-14",
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "py-2px"
  }, [_c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": "/terms/tos"
    }
  }, [_vm._v("이용약관")])], 1)]), _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "grey lighten-1 mx-8px",
    staticStyle: {
      "height": "12px"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "py-2px"
  }, [_c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": "/terms/privacy"
    }
  }, [_vm._v("개인정보취급방침")])], 1)]), _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "grey lighten-1 mx-8px",
    staticStyle: {
      "height": "12px"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "py-2px"
  }, [_c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": "/terms/protection-policy"
    }
  }, [_vm._v("청소년 보호방침")])], 1)]), _c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "grey lighten-1 mx-8px",
    staticStyle: {
      "height": "12px"
    },
    attrs: {
      "vertical": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "py-2px"
  }, [_c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": "/terms/cash-policy"
    }
  }, [_vm._v("나누리캐시 약관")])], 1)])], 1)], 1), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$vuetify.breakpoint.mobile,
      expression: "!$vuetify.breakpoint.mobile"
    }],
    attrs: {
      "cols": "auto"
    }
  }, [_c('a', {
    on: {
      "click": function click($event) {
        return _vm.open('https://instagram.com/daehan_bookstore?utm_medium=copy_link');
      }
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon-instagram.png"
    }
  })], 1)]), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$vuetify.breakpoint.mobile,
      expression: "!$vuetify.breakpoint.mobile"
    }],
    attrs: {
      "cols": "auto"
    }
  }, [_c('a', {
    on: {
      "click": function click($event) {
        return _vm.open('https://blog.naver.com/dhbooks_');
      }
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon-nblog.png"
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)], 1), _c('v-lazy', {
    attrs: {
      "transition": "fade-transition"
    },
    model: {
      value: _vm.showFooter,
      callback: function callback($$v) {
        _vm.showFooter = $$v;
      },
      expression: "showFooter"
    }
  }, [_c('v-footer', {
    staticClass: "px-0 py-26px pt-md-34px pb-md-40px",
    attrs: {
      "color": "white"
    }
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', [_c('v-img', {
    attrs: {
      "src": "/images/logo2.png",
      "width": _vm.$vuetify.breakpoint.mobile ? '120' : '165',
      "height": _vm.$vuetify.breakpoint.mobile ? '31' : '41',
      "contain": ""
    }
  })], 1), _c('v-spacer'), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$vuetify.breakpoint.mobile,
      expression: "$vuetify.breakpoint.mobile"
    }],
    attrs: {
      "cols": "auto"
    }
  }, [_c('a', {
    staticClass: "d-block pa-4px",
    on: {
      "click": function click($event) {
        return _vm.open('https://instagram.com/daehan_bookstore?utm_medium=copy_link');
      }
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon-instagram.png",
      "width": "24",
      "height": "24"
    }
  })], 1)]), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$vuetify.breakpoint.mobile,
      expression: "$vuetify.breakpoint.mobile"
    }],
    attrs: {
      "cols": "auto"
    }
  }, [_c('a', {
    staticClass: "d-block pa-4px",
    on: {
      "click": function click($event) {
        return _vm.open('https://blog.naver.com/dhbooks_');
      }
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/icon-nblog.png",
      "width": "24",
      "height": "24"
    }
  })], 1)])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "pt-20px pt-lg-0px pl-lg-20px"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "pr-lg-20px"
  }, [_c('div', {
    staticClass: "font-size-14 line-height-14 font-weight-bold grey--text text--darken-4"
  }, [_vm._v("선불전자지급수단 발행 · 관리(상품권 브랜드사)")]), _c('div', {
    staticClass: "mx-n4px mt-8px"
  }, [_c('v-row', {
    staticClass: "font-size-14 line-height-14 grey--text text--darken-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "px-4px pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("회사명")]), _c('span', [_vm._v("주식회사 페이솔루스")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("사업자등록번호")]), _c('span', [_vm._v("605-81-90742")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("선불전자지급수단 발행 및 관리업 등록번호")]), _c('span', [_vm._v("02-002-00020")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("통신판매 신고번호")]), _c('span', [_vm._v("2005-서울송파-3100")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("E-mail")]), _c('span', [_vm._v("Helpdesk@paysolus.co.kr")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("고객센터")]), _c('span', [_vm._v("1566-1291")])])])], 1)], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "mt-20px mt-lg-0px"
  }, [_c('div', {
    staticClass: "mx-n4px"
  }, [_c('v-row', {
    staticClass: "font-size-14 line-height-14 grey--text text--darken-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "px-4px pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("회사명")]), _c('span', [_vm._v("주식회사 대한문고")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("주소")]), _c('span', [_vm._v("서울특별시 강서구 마곡중앙로 171 마곡나루역 프라이빗타워2차 10층")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("대표번호")]), _c('span', [_vm._v("1800-9510")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("FAX")]), _c('span', [_vm._v("02-6442-9520")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("사업자등록번호")]), _c('span', [_vm._v("846-81-00822")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("통신판매업신고번호")]), _c('span', [_vm._v("제_2020-서울강서-1979 호")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("대표자")]), _c('span', [_vm._v("우상덕")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("개인정보관리책임자")]), _c('span', [_vm._v("서순명 이사")])])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pa-2px"
  }, [_c('b', {
    staticClass: "grey--text text--darken-4 mr-6px"
  }, [_vm._v("E-mail")]), _c('span', [_vm._v("help@daehanbooks.co.kr")])])])], 1)], 1)])])], 1), _c('div', {
    staticClass: "mt-16px"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/sgi-mark.png",
      "contain": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/biz-mark.svg",
      "contain": "",
      "width": "72"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "font-size-14 line-height-14 grey--text text--darken-2 mt-16px"
  }, [_c('div', [_vm._v("상표등록 출원번호 4020180121475, 4020210131548 무단 도용 시 법적 불이익을 받습니다.")]), _c('div', {
    staticClass: "mt-4px"
  }, [_vm._v("ⓒ 2022. BOOK Inc. all right reserved.")])])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._t("fab", [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showScroll,
      expression: "showScroll"
    }],
    staticClass: "mt-n10",
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "large": "",
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.scrollTo(0, 0);
      }
    }
  }, [_c('div', {
    staticClass: "pa-12px"
  }, [_c('v-icon', {
    staticClass: "my-n4px",
    attrs: {
      "size": "20"
    }
  }, [_vm._v("mdi-chevron-up")]), _c('div', {
    staticClass: "font-size-14 font-weight-medium mb-6px"
  }, [_vm._v("TOP")])], 1)])], {
    "scrollTo": _vm.scrollTo,
    "showScroll": _vm.showScroll
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }